import { InstantSearchServerState } from 'react-instantsearch'
import { isNonEmptyArray } from 'helpers/array'

export const getPagniationLinks = (
  initialResults:
    | InstantSearchServerState['initialResults'][number]
    | undefined,
  baseUrl: string
) => {
  if (!initialResults) return []
  const { results } = initialResults
  if (!results || !isNonEmptyArray(results)) return []
  const paginationState = results[0]

  const currentPage = paginationState.page ?? 0
  const totalPages = paginationState.nbPages ?? 0

  const paginationLinks: JSX.Element[] = []

  if (currentPage > 0) {
    const prevPage =
      currentPage === 1 ? `${baseUrl}` : `${baseUrl}?page=${currentPage}`

    paginationLinks.push(<link key="prev" rel="prev" href={prevPage} />)
  }

  if (currentPage < totalPages - 1) {
    const nextPage = `${baseUrl}?page=${currentPage + 2}`

    paginationLinks.push(<link key="next" rel="next" href={nextPage} />)
  }

  return paginationLinks
}
